// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__4NpGn","topLeft":"style_topLeft__E7qSK","topRight":"style_topRight__IIVgh","bottomLeft":"style_bottomLeft__hnZE3","bottomRight":"style_bottomRight__UnWdQ"};